module.exports = __webpack_public_path__ + "icon_laixin.png?53f2e3fa7701f186147c3e1f2a4db0bd";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icon_laixin.png
// module id = 532
// module chunks = 0